import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LockedFeatureProps {
  /** Human-readable feature name, e.g. "Agent LiLi". */
  feature: string;
}

/**
 * Inline locked state shown in the content area when a non-subscriber lands on
 * a premium route (deep link / direct nav). It renders INSTEAD of the real
 * page (see [[FeatureGate]]) so the page's guarded API calls never fire — the
 * FE-side way to keep a no-plan user out of guarded endpoints. The upgrade CTA
 * routes to the full-screen Paywall at `/app/upgrade`.
 */
export function LockedFeature({ feature }: LockedFeatureProps) {
  const navigate = useNavigate();

  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto mb-6 inline-flex size-16 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500">
          <Lock className="size-7 text-white" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">{feature} is a premium feature</h1>
        <p className="text-gray-600 mb-8">
          Subscribe to unlock {feature} and the rest of your LiLi workspace. You can keep exploring
          the app any time.
        </p>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button
            onClick={() => navigate('/app/upgrade')}
            className="h-11 w-full justify-center gap-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:from-purple-700 hover:to-pink-700 sm:w-auto"
          >
            <Sparkles className="size-4" />
            View plans &amp; upgrade
          </Button>
          <Button
            variant="outline"
            className="h-11 w-full justify-center gap-2 sm:w-auto"
            onClick={() => navigate('/app/dashboard')}
          >
            Back to home
            <ArrowRight className="size-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
